import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "17",
      height: "17",
      x: "1.5",
      y: "1.5",
      stroke: "currentColor",
      rx: ".5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m10 1 .834 6.432L15.29 2.72l-3.106 5.694L18.56 7.22 12.7 10l5.86 2.781-6.376-1.194 3.106 5.694-4.456-4.713L10 19l-.834-6.432L4.71 17.28l3.106-5.694L1.44 12.78 7.3 10 1.44 7.219l6.376 1.194L4.71 2.719l4.456 4.713z"
    }, null, -1)
  ])))
}
export default { render: render }